import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as UnlinkIcon } from 'src/assets/icon_unlink.svg';
import { SvgWrapper } from 'src/components/SvgWrapper';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { IBitrixDealPlacement } from 'src/store/crosstable/reducer';
import { useSelector } from 'react-redux';
import { getCurrentLang } from 'src/store/app/selectors';
import { useStyles } from './styles';

interface Props {
  placementDeal: IBitrixDealPlacement | undefined;
  onProgress?: (progress: number) => void;
  onUndo?: () => void;
}
export const ApartmentSidebarUndo: React.FC<Props> = ({ placementDeal, onProgress, onUndo }) => {
  const currentLang = useSelector(getCurrentLang);
  const styles = useStyles();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (onProgress) onProgress(progress);
  }, [progress, onProgress]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress: number) => {
        if (oldProgress >= 100) {
          // Stop ticking once the window is over — a live interval kept firing
          // state updates until unmount.
          clearInterval(timer);
          return oldProgress;
        }
        return Math.min(oldProgress + 20, 100);
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const undoAction = () => {
    if (onUndo) {
      onUndo();
    }
  };

  return (
    <div className={styles.undoWrapper}>
      <div className={styles.infoWrapper}>
        <div className={styles.info}>
          <div className="info-icon">
            <SvgWrapper size={16}>
              <UnlinkIcon />
            </SvgWrapper>
          </div>
          <div className="info-id">
            Unlinking
            {' '}
            #
            {placementDeal?.numeration?.[currentLang]}
          </div>
        </div>
        <Box className="info-text" onClick={undoAction}>Undo</Box>
      </div>
      <div className={styles.process}>
        <LinearProgress
          variant="determinate"
          value={progress}
        />
      </div>
    </div>
  );
};
